<template>
  <div>
    <hd></hd>
    <el-row class="tac">
      <el-col :span="5">
        <leftMenu></leftMenu>
      </el-col>
      <el-col :span="19" class="main-content">
        <h2>{{method}}</h2>
        <commmonArg v-if="showData" :contentEditable="contentEditable"></commmonArg>
        <openApiUseWay
          v-if="showData"
          :NotificaitonURL="NotificaitonURL"
          :contentEditable="contentEditable"
          :method="method"
        ></openApiUseWay>
        <openApiSign
          v-if="showData"
          :contentEditable="contentEditable"
          :method="method"
        ></openApiSign>
        <xmlContent
          v-if="showData"
          :contentEditable="contentEditable"
          :xml="openapiMethodData.xmlRequest"
          :title="$t('message.RequestParameter')"
        ></xmlContent>
        <xmlContent
          v-if="showData"
          :contentEditable="contentEditable"
          :xml="openapiMethodData.xmlResponse"
          :title="$t('message.ResponseParameter')"
        ></xmlContent>
        <openApiTools
          :method="method"
          :type="type"
        ></openApiTools>
        <!--<el-switch
          style="display: block"
          v-model="contentEditable"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-text="编辑"
          inactive-text="预览">
        </el-switch>-->
      </el-col>
    </el-row>
  </div>
</template>

<script>
import hd from '../components/Header'
import commmonArg from '../components/openapi/CommonArg'
import openApiUseWay from '../components/openapi/OpenApiUseWay'
import openApiSign from '../components/openapi/OpenApiSign'
import openApiTools from '../components/openapi/OpenApiTools'

import xmlContent from '../components/XmlContent'
import leftMenu from '../components/LeftMenu'
import openapiItemSynchronize from '../data/openapi/openapi.items.synchronize.js'
import openapiSingleitemSynchronize from '../data/openapi/openapi.singleitem.synchronize.js'
import openapiSingleitemPush from '../data/openapi/openapi.singleitem.push.js'
import openapiCombineitemSynchronize from '../data/openapi/openapi.combineitem.synchronize.js'
import openapiEntryorderBatchCreate from '../data/openapi/openapi.entryorder.batchcreate.js'
import openapiEntryorderCreate from '../data/openapi/openapi.entryorder.create.js'
import openapiEntryorderReceive from '../data/openapi/openapi.entryorder.receive.js'
import openapiEntryorderConfirm from '../data/openapi/openapi.entryorder.confirm.js'
import openapiEntryorderPush from '../data/openapi/openapi.stockin.push.js'
import openapiEntryorderUpdate from '../data/openapi/openapi.entryorder.update.js'
import openapiEntryorderBatchUpdate from '../data/openapi/openapi.entryorder.batchupdate.js'
import openapiStockoutCreate from '../data/openapi/openapi.stockout.create.js'
import openapiStockoutBatchCreate from '../data/openapi/openapi.stockout.batchcreate.js'
import openapiStockoutConfirm from '../data/openapi/openapi.stockout.confirm.js'
import openapiStockoutClose from '../data/openapi/openapi.stockout.close.js'
import openapiStockoutQuery from '../data/openapi/openapi.stockout.query.js'
import openapiInventoryQuery from '../data/openapi/openapi.inventory.query.js'
import openapiConditionInventoryQuery from '../data/openapi/openapi.conditioninventory.query.js'
import openapiInventoryReport from '../data/openapi/openapi.inventory.report.js'
import openapiOrderCancel from '../data/openapi/openapi.order.cancel.js'
import openapiStoreprocessCreate from '../data/openapi/openapi.storeprocess.create.js'
import openapiStoreprocessConfirm from '../data/openapi/openapi.storeprocess.confirm.js'
import openapiAdjustmentorderCreate from '../data/openapi/openapi.adjustmentorder.create.js'
import openapiAdjustmentorderConfirm from '../data/openapi/openapi.adjustmentorder.confirm.js'
import openapiSaleorderCreate from '../data/openapi/openapi.saleorder.create.js'
import openapiSaleorderConfirm from '../data/openapi/openapi.saleorder.confirm.js'
import openapiPackuomSingleitemSynchronize from '../data/openapi/openapi.packuom.singleitem.synchronize.js'
import openapiSingleitemQuery from '../data/openapi/openapi.singleitem.query.js'
import openapiStockoutPush from '../data/openapi/openapi.stockout.push.js'
import openapiTransportCreate from '../data/openapi/openapi.transport.create.js'
import openapiRoutingReceive from '../data/openapi/openapi.routing.receive.js'
import openapiRoutingPush from '../data/openapi/openapi.routing.push.js'
import openapiWaybillGet from '../data/openapi/openapi.waybill.get'
import openapiSerialnoSynchronize from '../data/openapi/openapi.serialno.synchronize.js'
import openapiUserSynchronize from '../data/openapi/openapi.user.synchronize.js'
// import menus from '../data/apis.js'

export default {
  components: {
    commmonArg,
    leftMenu,
    xmlContent,
    openApiUseWay,
    openApiSign,
    openApiTools,
    hd
  },
  name: 'HelloWorld',
  created () {
    this.contentEditable = false
    this.method = this.$route.query.method || 'openapi.singleitem.synchronize'
    this.type = this.$route.query.type || 'openapi'
    this.setData(this.method)
    this.setTitle()
  },
  data () {
    return {
      content: '## 请求参数\n',
      method: null,
      type: null,
      contentEditable: true,
      openapiMethodData: {
        xmlResponse: '',
        xmlRequest: ''
      },
      openapiData: {
        'openapi.singleitem.synchronize': openapiSingleitemSynchronize,
        'openapi.items.synchronize': openapiItemSynchronize,
        'openapi.combineitem.synchronize': openapiCombineitemSynchronize,
        'openapi.entryorder.batchcreate': openapiEntryorderBatchCreate,
        'openapi.entryorder.create': openapiEntryorderCreate,
        'openapi.entryorder.receive': openapiEntryorderReceive,
        'openapi.entryorder.confirm': openapiEntryorderConfirm,
        'openapi.stockin.push': openapiEntryorderPush,
        'openapi.entryorder.update': openapiEntryorderUpdate,
        'openapi.entryorder.batchupdate': openapiEntryorderBatchUpdate,
        'openapi.stockout.create': openapiStockoutCreate,
        'openapi.stockout.batchcreate': openapiStockoutBatchCreate,
        'openapi.stockout.confirm': openapiStockoutConfirm,
        'openapi.stockout.close': openapiStockoutClose,
        'openapi.stockout.query': openapiStockoutQuery,
        'openapi.stockout.push': openapiStockoutPush,
        'openapi.inventory.query': openapiInventoryQuery,
        'openapi.conditioninventory.query': openapiConditionInventoryQuery,
        'openapi.inventory.report': openapiInventoryReport,
        'openapi.order.cancel': openapiOrderCancel,
        'openapi.storeprocess.create': openapiStoreprocessCreate,
        'openapi.storeprocess.confirm': openapiStoreprocessConfirm,
        'openapi.adjustmentorder.create': openapiAdjustmentorderCreate,
        'openapi.adjustmentorder.confirm': openapiAdjustmentorderConfirm,
        'openapi.saleorder.create': openapiSaleorderCreate,
        'openapi.saleorder.confirm': openapiSaleorderConfirm,
        'openapi.packuom.singleitem.synchronize': openapiPackuomSingleitemSynchronize,
        'openapi.singleitem.push': openapiSingleitemPush,
        'openapi.transport.create': openapiTransportCreate,
        'openapi.routing.receive': openapiRoutingReceive,
        'openapi.routing.push': openapiRoutingPush,
        'openapi.waybill.get': openapiWaybillGet,
        'openapi.serialno.synchronize': openapiSerialnoSynchronize,
        'openapi.singleitem.query': openapiSingleitemQuery,
        'openapi.user.synchronize': openapiUserSynchronize
      },
      showData: true
    }
  },
  methods: {
    highlightRequired () {
      $.each($('code'), (key, code) => {
        let html = $(code).html()
        html = html.replace(/必填/g, '<span class="hljs-string">必填</span>')
        html = html.replace(/条件<span class="hljs-string">必填<\/span>/g, '<span class="hljs-string">条件必填</span>')
        html = html.replace(/可更新/g, '<span style="color: blue;">可更新</span>')
        $(code).html(html)
      })
    },
    setData (method) {
      if (this.openapiData[method]) {
        this.openapiMethodData.xmlRequest = this.openapiData[method].xmlRequest
        this.openapiMethodData.xmlResponse = this.openapiData[method].xmlResponse
        this.NotificaitonURL = this.openapiData[method].NotificaitonURL
      } else {
        this.openapiMethodData.xmlRequest = ''
        this.openapiMethodData.xmlResponse = ''
      }
      this.showData = true
      setTimeout(() => {
        this.highlightRequired()
      }, 500)
    },
    setTitle () {

    }
  },
  watch: {
    '$route.query': {
      handler (newVal, oldVal) {
        this.showData = false
        this.method = newVal.method
        this.type = newVal.type
        setTimeout(() => {
          this.setData(this.method)
        })
        this.setTitle()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/OpenApi.vue